import { render, staticRenderFns } from "./SearchAdd.vue?vue&type=template&id=01c84bb5"
import script from "./SearchAdd.vue?vue&type=script&lang=js"
export * from "./SearchAdd.vue?vue&type=script&lang=js"
import style0 from "./SearchAdd.vue?vue&type=style&index=0&id=01c84bb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports